import { Metadata } from '@redwoodjs/web';
import { RiCloseLine } from '@remixicon/react';
import DeleteButton from 'src/components/atoms/buttons/DeleteButton';
import { customerPortalPurchaseOrderStatuses } from 'src/components/atoms/StatusStepper';
import { PageBody } from 'src/components/containers/PageBody';
import { PageHeader, PageType } from 'src/components/containers/PageHeader';
import { AgButton } from 'src/components/ui';

import useCustomerPortalApi from '../useCustomerPortalApi';

import EditCustomerPortalPurchaseOrder from './EditCustomerPortalPurchaseOrder';
import OrderSkeleton from './OrderSkeleton';
import useCustomerPortalPurchaseOrder from './useCustomerPortalPurchaseOrder';

export default function EditCustomerPortalPurchaseOrderPage({ slug }) {
  const { submitPurchaseOrder, cancelPurchaseOrder } = useCustomerPortalApi();
  const purchaseOrder = useCustomerPortalPurchaseOrder(slug);

  return (
    <>
      <Metadata title={`#PO ${slug}`} />
      <PageHeader pageType={PageType.CustomerPortalPurchaseOrder} entitySlug={slug}>
        <div className="ml-auto my-auto flex gap-1">
          {purchaseOrder && (
            <>
              {purchaseOrder.status === 'DRAFT' && (
                <DeleteButton
                  title="Delete Purchase Order"
                  hint="Delete order"
                  prompt={`Do you want to delete Purchase Order #${slug}?`}
                  handleConfirm={() => {
                    cancelPurchaseOrder(purchaseOrder.id, purchaseOrder.status);
                  }}
                />
              )}
              {purchaseOrder.status === 'PENDING' && (
                <DeleteButton
                  title="Cancel Purchase Order"
                  hint="Cancel order"
                  prompt={`Do you want to cancel Purchase Order #${slug}?`}
                  label="Cancel"
                  icon={<RiCloseLine size={20} />}
                  handleConfirm={() => {
                    cancelPurchaseOrder(purchaseOrder.id, purchaseOrder.status);
                  }}
                />
              )}
              <AgButton
                variant="primary"
                isDisabled={purchaseOrder.status !== 'DRAFT'}
                onPress={() => submitPurchaseOrder(purchaseOrder.id)}
              >
                {purchaseOrder.status !== 'DRAFT' ? 'Submitted' : 'Submit Order'}
              </AgButton>
            </>
          )}
        </div>
      </PageHeader>
      <PageBody sx={{ flexDirection: 'column' }}>
        {purchaseOrder ? (
          <EditCustomerPortalPurchaseOrder purchaseOrder={purchaseOrder} />
        ) : (
          <OrderSkeleton statuses={customerPortalPurchaseOrderStatuses} />
        )}
      </PageBody>
    </>
  );
}
